import { Box } from "@mui/material"
import React, { PropsWithChildren } from "react"

interface CallBadgeProps {
  emphasis?: "default" | "danger"
}

export function CallBadge({
  emphasis = "default",
  children,
}: PropsWithChildren<CallBadgeProps>) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "var(--spacing-tokens-size-in-px-spacing-spacing-xs)",
        paddingX: "var(--spacing-tokens-size-in-px-spacing-spacing-lg)",
        paddingY: "var(--spacing-tokens-size-in-px-spacing-spacing-sm)",
        borderRadius: "var(--spacing-tokens-size-in-px-radius-radius-full)",
        backgroundColor:
          emphasis === "danger"
            ? "var(--color-background-bg-error-subtle)"
            : "var(--call-chip-bg)",
        color: "var(--color-text-text-white)",
        fontFamily: "var(--app-font-family, figtree, sans-serif)",
        fontSize: "var(--global-text-s-medium-font-size)",
        fontWeight: "var(--global-text-s-medium-font-weight)",
        lineHeight: "calc(var(--global-text-s-medium-line-height) * 1px)",
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </Box>
  )
}
